//import React from 'react';
import React, { useState } from 'react';

import Header from './Header';
import Footer from './Footer';
const Layout = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);

  const handleCartUpdate = (count) => {
    setCartCount(count);
  };
  const bgUrl = `${process.env.REACT_APP_WEB_BASE_URL}/images/bg.png`;

  const layoutStyle = {
    backgroundImage: `url(${bgUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  };

  return (
    <div style={layoutStyle}>
      <Header onCartUpdate={handleCartUpdate} />

      <main className="container my-4">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;

